"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.primaryLink = void 0;
function primaryLink({ links, primaryLinkId, }) {
    const primaryLink = links.find((link) => link === primaryLinkId);
    if (primaryLink != null) {
        return primaryLink;
    }
    else {
        // else default to first link
        return links[0] != null ? links[0] : null;
    }
}
exports.primaryLink = primaryLink;
//# sourceMappingURL=primaryLink.js.map